/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_QueuedInputs */

const en_import_status_queued = /** @type {(inputs: Import_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queued`)
};

const de_import_status_queued = /** @type {(inputs: Import_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Warteschlange`)
};

/**
* | output |
* | --- |
* | "Queued" |
*
* @param {Import_Status_QueuedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_queued = /** @type {((inputs?: Import_Status_QueuedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_QueuedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_queued(inputs)
	return en_import_status_queued(inputs)
});